// extracted by mini-css-extract-plugin
export default {"icon":"HyxRY6","reversedIcon":"HAA35J","overflow":"kRVkro","title":"J8GA_Q","mobile":"rBdkR1","listContentTitleColor":"DktTqT"};